import React from 'react';

const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];
  
  // Create an array of page numbers to display
  if (totalPages <= 7) {
    // If there are 7 or fewer pages, show all page numbers
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  } else {
    // Always include first page
    pageNumbers.push(1);
    
    // If current page is 1, 2 or 3, show first 5 pages, then ellipsis, then last page
    if (currentPage < 4) {
      pageNumbers.push(2, 3, 4, 5, '...', totalPages);
    } 
    // If current page is among the last 3 pages, show first page, then ellipsis, then last 5 pages
    else if (currentPage > totalPages - 3) {
      pageNumbers.push('...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } 
    // Otherwise show first page, ellipsis, current page and its neighbors, ellipsis, last page
    else {
      pageNumbers.push('...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
    }
  }
  
  return (
    <div className="flex justify-center items-center space-x-2">
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className={`px-3 py-1 rounded-md ${
          currentPage === 1
            ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
            : 'bg-blue-50 text-blue-600 hover:bg-blue-100'
        }`}
      >
        Previous
      </button>
      
      {pageNumbers.map((number, index) => (
        <button
          key={index}
          onClick={() => typeof number === 'number' ? onPageChange(number) : null}
          className={`px-3 py-1 rounded-md ${
            number === currentPage
              ? 'bg-blue-500 text-white'
              : number === '...'
              ? 'bg-white text-gray-500 cursor-default'
              : 'bg-blue-50 text-blue-600 hover:bg-blue-100'
          }`}
        >
          {number}
        </button>
      ))}
      
      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 rounded-md ${
          currentPage === totalPages
            ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
            : 'bg-blue-50 text-blue-600 hover:bg-blue-100'
        }`}
      >
        Next
      </button>
    </div>
  );
};

export default PaginationControls;
